const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls, MediaUpload } = wp.blockEditor;

const { Button, SelectControl, PanelBody, Disabled, ToggleControl } = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/dynamic-image", {
	title: __("Image Dynamique", "wp-apidae"), // Block title.
	description: __("Affiche l'image à la une de la fiche.", "wp-apidae"),
	icon: {
		foreground: "#EFB114",
		background: "#331F5B",
		src: icons.dynamicImage,
	},
	supports: {
		align: ["full", "wide"],
	},
	example: {},
	attributes: {
		dynamic_image_size: {
			type: "string",
			default: "full",
		},
		fallback_image: {
			type: "number",
		},
		fallback_image_url: {
			type: "string",
		},
		align: {
			type: "string",
			default: "",
		},
		post_link: {
			type: "boolean",
			default: false,
		},
	},
	usesContext: ["postId", "postType", "queryId"],
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;
			const imageSizes = window.WpApidaeTemplateData.imageSizes;

			var template = window.WpApidaeTemplateData.settings;

			return [
				props.isSelected && (
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("General")}>
							<SelectControl
								label={__("Image Size")}
								value={attributes.dynamic_image_size}
								options={imageSizes}
								onChange={(newValue) => {
									props.setAttributes({
										dynamic_image_size: newValue,
									});
								}}
							/>
							{attributes.fallback_image_url && (
								<span class="components-responsive-wrapper">
									<img src={attributes.fallback_image_url} />
								</span>
							)}
							<MediaUpload
								onSelect={(media) => {
									props.setAttributes({
										fallback_image: media.id,
										fallback_image_url: media.url,
									});
								}}
								type="image"
								value={attributes.fallback_image}
								render={({ open }) => (
									<div class="editor-post-featured-image">
										<div class="editor-post-featured-image__container">
											<Button
												className="components-button editor-post-featured-image__toggle"
												onClick={open}
											>
												{__("Définir l'image par défaut")}
											</Button>
										</div>
									</div>
								)}
							/>
							{attributes.fallback_image_url && (
								<Button
									onClick={() => {
										props.setAttributes({
											fallback_image: 0,
											fallback_image_url: "",
										});
									}}
									isLink
									isDestructive
								>
									{__("Supprimer l'image par défaut")}
								</Button>
							)}
							<ToggleControl
								label={ __( 'Inclure le lien du post' ) }
								checked={ attributes.post_link }
								onChange={ () => {
									props.setAttributes({ post_link: ! attributes.post_link });
								} }
							/>
						</PanelBody>
					</InspectorControls>
				),
				<Disabled>
					<ServerSideRender
						block="wp-apidae/dynamic-image"
						attributes={attributes}
						urlQueryArgs={{
							settings: template,
						}}
					/>
				</Disabled>,
			];
		}
	},

	save: () => {
		return null;
	},
});
